import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompletion = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.28 7.28133C14.3993 7.22868 14.5006 7.14218 14.5713 7.03254C14.642 6.92289 14.6789 6.79493 14.6775 6.66449C14.6762 6.53406 14.6366 6.40688 14.5637 6.29872C14.4908 6.19056 14.3877 6.10617 14.2673 6.056L8.55333 3.45333C8.37962 3.3741 8.19093 3.3331 8 3.3331C7.80907 3.3331 7.62037 3.3741 7.44667 3.45333L1.73333 6.05333C1.61464 6.10531 1.51368 6.19076 1.44278 6.29921C1.37188 6.40766 1.33412 6.53443 1.33412 6.664C1.33412 6.79357 1.37188 6.92034 1.44278 7.02879C1.51368 7.13724 1.61464 7.22268 1.73333 7.27467L7.44667 9.88C7.62037 9.95923 7.80907 10.0002 8 10.0002C8.19093 10.0002 8.37962 9.95923 8.55333 9.88L14.28 7.28133Z",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6667 6.66667V10.6667",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 8.33333V10.6667C4 11.1971 4.42143 11.7058 5.17157 12.0809C5.92172 12.456 6.93913 12.6667 8 12.6667C9.06087 12.6667 10.0783 12.456 10.8284 12.0809C11.5786 11.7058 12 11.1971 12 10.6667V8.33333",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCompletion;
